import { render, staticRenderFns } from "./AvatarMenu.vue?vue&type=template&id=03acb11a&"
import script from "./AvatarMenu.vue?vue&type=script&lang=ts&"
export * from "./AvatarMenu.vue?vue&type=script&lang=ts&"
import style0 from "./AvatarMenu.vue?vue&type=style&index=0&id=03acb11a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports